import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, linkTo, linkLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap">
      <div className="max-w-2xl">
        <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase">{eyebrow}</p>
        <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="group inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          {linkLabel}
          <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
            <i className="ri-arrow-right-line" />
          </span>
        </Link>
      )}
    </div>
  );
}